module.exports = __webpack_public_path__ + "static/media/1POLICY12.ec771455.jpg";